import React, { Component } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import PropTypes from 'prop-types'
import { Typography, Grid } from '@material-ui/core'
import { Translate, getTranslate } from 'react-localize-redux'
import { IsNullOrEmpty } from '../../store/helpers/StringHelper'
import { connect } from 'react-redux'

class HtmlEditor extends Component {
	constructor(props) {
		super(props)

		this.state = {
			value: props.initialValue || '',
			userTyping: false,
		}
		this._debounceTimer = null
	}

	componentDidUpdate(prevProps) {
		if (prevProps.initialValue !== this.props.initialValue) {
			this.setState({
				value: this.props.initialValue || '',
				userTyping: false,
			})
		}
	}

	componentWillUnmount() {
		clearTimeout(this._debounceTimer)
	}

	handleEditorChange = (content) => {
		this.setState({
			value: content,
			userTyping: true,
		})

		if (this.props.isDisabled) return

		clearTimeout(this._debounceTimer)
		this._debounceTimer = setTimeout(() => {
			if (this.props.onChange) {
				this.props.onChange({
					id: this.props.id,
					value: content,
				})
			}

			if (this.props.onEditorChange) {
				this.props.onEditorChange(content)
			}
		}, 500)
	}

	render() {
		const modules = {
			toolbar: this.props.isDisabled
				? false
				: [
						[{ size: ['small', false, 'large', 'huge'] }],
						['bold', 'italic', 'underline', 'strike'],
						[{ color: [] }, { background: [] }],
						[{ align: [] }],
						[{ list: 'ordered' }, { list: 'bullet' }],
						[{ indent: '-1' }, { indent: '+1' }],
						['clean'],
				  ],
			history: {
				delay: 500,
				maxStack: 100,
				userOnly: true,
			},
		}

		const formats = [
			'size',
			'bold',
			'italic',
			'underline',
			'strike',
			'color',
			'background',
			'align',
			'list',
			'indent',
		]

		const editorValue = IsNullOrEmpty(this.state.value)
			? this.props.isDisabled
				? `<p>-${this.props.translate('common.withoutData')}-</p>`
				: ''
			: this.state.value

		return (
			<Grid container spacing={0}>
				{this.props.label && (
					<Grid item xs={12}>
						<Typography
							variant={this.props.labelVariant && this.props.labelVariant}
							color={this.props.labelColor && this.props.labelColor}
						>
							{this.props.label && <Translate id={this.props.label} />}
						</Typography>
					</Grid>
				)}

				<Grid item xs={12}>
					<ReactQuill
						theme="snow"
						value={editorValue}
						onChange={this.handleEditorChange}
						modules={modules}
						formats={formats}
						readOnly={this.props.isDisabled}
						style={{
							height: this.props.height
								? this.props.height
								: '250px',
							marginBottom: '50px',
						}}
					/>
				</Grid>
			</Grid>
		)
	}
}

HtmlEditor.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	labelVariant: PropTypes.string,
	labelColor: PropTypes.string,
	isDisabled: PropTypes.bool.isRequired,
	initialValue: PropTypes.string,
	onChange: PropTypes.func,
	onEditorChange: PropTypes.func,
	height: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
}

function mapStateToProps(state) {
	return {
		translate: getTranslate(state.localize),
	}
}

export default connect(mapStateToProps, null)(HtmlEditor)